import { Route, RouteGroup } from '@billow/easy-route'

export default RouteGroup({

  middleware: ['auth', 'active-subscriber'],

  routes: [
    Route('/teams', 'teams', () => import('@/views/teams/Index.vue')),
    Route('/team', 'create-team', () => import('@/views/teams/Create.vue')),
    Route('/teams/:team', 'team-manager', () => import('@/views/teams/Manager.vue')),
    Route('/teams/:team/invite', 'team-invite-user', () => import('@/views/teams/NewInvite.vue')),
    Route('/invitations', 'invitations', () => import('@/views/teams/Invites.vue')),
  ]
})